<template>
  <v-container class="ma-10 mx-auto" style="max-width: 300px;">
    <vue-headful title="Passwort Zurücksetzen" description="Aimz"/>

    <v-row class="pt-10 pb-3">
      <v-col>
        <h1 class="display-1 gelb--text text-center">Passwort zurücksetzen</h1>
      </v-col>
    </v-row>

    <div v-if="status=='send'">
      <v-text-field label="Email" v-model="email"></v-text-field>
      <v-btn color="gelb" class="full_width white--text mt-5" @click="onSendPwResetEmail">Passwort zurücksetzen</v-btn>
    </div>

    <div v-else-if="status=='email_sent'">
      <v-alert type="success">
        Ein Link wurde an {{email}} gesendet.
      </v-alert>
      <p>
        Tip: prüfen Sie auch den Spamordner.
      </p>
    </div>

    <div v-else-if="status=='send_failed'">
      <v-alert type="error">
        Das Passwort für {{email}} konnte nicht zurückgesetzt werden.
      </v-alert>
      <p>
        {{resend_error}}
      </p>
      <v-btn class="gelb full_width" dark @click="request_activation_email">Neuer Versuch</v-btn>
    </div>

    <div v-else-if="status=='reset_with_code'">
      <v-form v-model="valid" ref="form" v-if="!success">
        <v-row>
          <v-col class="py-0">
            <v-alert v-if="capslock" type="warning">
              FESTSTELLTASTE AKTIV
            </v-alert>
            <v-text-field name="xyz2" class="full_width" placeholder="Neues Passwort" v-model="pw1" :rules="pw1Rules" required type="password" autocomplete="new-password"></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <v-text-field name="xyz3" class="full_width" placeholder="Passwort wiederholen" v-model="pw2" :rules="pw2Rules" required type="password" autocomplete="new-password"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-btn class="gelb full_width white--text mt-5" @click="onResetPw" :disabled="!valid">Speichern</v-btn>
    </div>

    <!--    <div v-if="status=='activate_with_code'">Aktivierungscode prüfen ...</div>-->
    <div v-else-if="status=='pw_changed'">
      <v-alert type="success">
        Ihr Passwort wurde geändert.
      </v-alert>
      Sie können sich nun <router-link to="/login">einloggen</router-link>
    </div>
    <div v-else-if="status=='pw_reset_failed'">
      <v-alert type="error">
        Passwort-Änderung fehlgeschlagen
      </v-alert>
      <p>
        {{activation_error}}
      </p>
      <p>
        Probieren Sie es <router-link to="/pw_reset">noch einmal.</router-link>
      </p>
    </div>
  </v-container>
</template>


<script>
    // @ is an alias to /src

    export default {
        name: 'PwReset',
        components: {  },
        data() {return{
            status:'send', // send | email_sent | activate_with_code | activated ...
            email:'',
            capslock:false,
            valid:false,
            reset_code:'',
            pw1:'',
            pw2:'',
            pw1Rules: [
                v => !!v || 'Bitte ein Passwort wählen',
                v => v.length >= 8 || 'Passwort muss aus mindestens 8 Zeichen bestehen',
                v => /\d/.test(v) || 'Passwort muss mindestens eine Ziffer beinhalten',
                v => /[A-Z]/.test(v) || 'Passwort muss mindestens einen Großbuchstaben beinhalten',
                v => /[a-z]/.test(v) || 'Passwort muss mindestens einen Kleinbuchstaben beinhalten',
            ],
            pw2Rules: [
                v => !!v || 'Bitte nochmal eingeben',
                v => v==this.pw1 || 'Passwörter stimmen nicht überein',
            ],
            activation_error:undefined,
            resend_error:undefined,
        }},
        mounted() {
            this.onRouteChange();
            document.addEventListener( 'keydown', this.onKeyDown);
        },
        beforeDestroy() {
            document.removeEventListener( 'keydown', this.onKeyDown);
        },
        methods:{
            reset(id) {
                this.status='reset_with_code'
                this.reset_code=id;
                this.pw1='';
                this.pw2='';
            },
            onResetPw() {
                this.$backend.reset_password( {id:this.reset_code, pw:this.pw1 }, { onSuccess:this.onSuccess, onError:this.onError });
            },
            onSuccess() {
                this.status='pw_changed';
            },
            onError(reason) {
                this.status='pw_reset_failed';
                this.activation_error=reason;
                // display email textbox to resend code
            },
            onSendPwResetEmail() {
                this.$backend.request_pw_reset( this.email, {
                    onSuccess:()=>{
                        this.status="email_sent";
                    },
                    onError:(reason)=> {
                        this.status="send_failed";
                        this.resend_error=reason;
                    }});
            },
            send_pw_reset_email() {
                this.status="send";
                this.email='';
            },
            onRouteChange(){
                var id=this.$route.params.id;
                if (id)
                    this.reset(id);
                else
                    this.send_pw_reset_email();
            },
            onKeyDown( event ) {
                this.capslock = event.getModifierState && event.getModifierState( 'CapsLock' );
                //console.log( this.caps ); // true when you press the keyboard CapsLock key
            },
        },
        watch: {
            $route(to, from) {
                // react to route changes...
                this.onRouteChange();
            }
        }
    }
</script>
